import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-delete-address-warning',
  templateUrl: './delete-address-warning.component.html',
  styleUrls: ['./delete-address-warning.component.scss', '../../account/card-style.scss'],
  standalone: false
})
export class DeleteAddressWarningComponent implements OnInit {

  @Input() address;
  @Input() type;

  constructor(
    private modalController: ModalController
  ) { }

  ngOnInit() { }

  close() {
    this.modalController.dismiss({ delete: false });
  }

  accept() {
    this.modalController.dismiss({ delete: true });
  }

}
